import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FSAppsService } from 'app/_services/fsapps.service';

@Component({
    selector: 'app-sign-in',
    template: '',
    standalone: false
})
export class SignInComponent implements OnInit {
  constructor(private route: ActivatedRoute, private fsappsService: FSAppsService) {}

  ngOnInit() {
    const code = this.route.snapshot.queryParamMap.get('code');
    this.fsappsService.getToken(code).subscribe((response) => {
    });
  }
}
